module.exports = "/_next/static/images/557fbc1bb401594a757807772a565683-apply-bullet-3.jpeg.webp";